module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reward-rules"
  }, [_c('p', {
    staticClass: "question"
  }, [_vm._v(_vm._s(_vm.$t('question')))]), _vm._v(" "), _c('div', {
    staticClass: "answer"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('answer')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require('../../../static/img/rewardRules/' + _vm.$t('img') + '.png'),
      "alt": _vm.$t('img')
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-925e7d0a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/rewardRules/rewardRules.vue
// module id = 1368
// module chunks = 1